/**
 * Created by PanJiaChen on 16/11/18.
 */
var sha512 = require('js-sha512')
const Base64 = require('js-base64').Base64
/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal (path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername (str) {
  const validMap = ['admin', 'editor']
  return validMap.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL (url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase (str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase (str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets (str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail (email) {
  // eslint-disable-next-line no-useless-escape
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString (str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray (arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

// 由字母与数字组合的随机字符串
export const randomRange = (min, max) => {
  var returnStr = ''
  var range = (max ? Math.round(Math.random() * (max - min)) + min : min)
  var charStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

  for (var i = 0; i < range; i++) {
    var index = Math.round(Math.random() * (charStr.length - 1))
    returnStr += charStr.substring(index, index + 1)
  }
  return returnStr
}

// 由数字组合的随机字符串
export const randomRangeNumber = (max) => {
  var Num = ''
  for (var i = 0; i < max; i++) {
    Num += Math.floor(Math.random() * 10)
  }
  return Num
}

export const sign = function (params, randomNum) {
  const string = Object.keys(params).sort().map(key => `${key}=${params[key]}`).join('&')
  let signKey
  switch (process.env.CUSTOM_ENV) {
    case 'test': {
      signKey = 'yeahka201900910yahdkk2nightahjsfj'
      break
    }
    case 'pre': {
      signKey = 'yeahka20190910ksjqwlfj72kd0qksw1'
      break
    }
    case 'prd': {
      signKey = 'yeahka20190910ksjqwlfj72kd0qksw1'
      break
    }
    default: {
      signKey = 'yeahka201900910yahdkk2nightahjsfj'
    }
  }
  const middleString = string + signKey + randomNum
  return Base64.encode(sha512((middleString)))
}

// 8-20位大小写字母、数字、符号中的至少三种组合登录密码
export function validStrictPsd (str) {
  const reg = /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z_\W]+$)(?![a-z\d]+$)(?![a-z_\W]+$)(?![\d_\W]+$)[^\u4e00-\u9fa5\s]{8,20}$/
  return reg.test(str)
}
export const strictPsdError = '密码为8-20位大写/小写字母/数字/符号中的至少三种组合'

// 8-20位大写字母，小写字母和数字三种组合登录密码
export function validSimplePsd (str) {
  const reg = /^(?![a-z0-9]+$)(?![A-Z0-9]+$)(?![a-zA-Z]+$)[a-zA-Z0-9]{8,20}$/
  return reg.test(str)
}
export const simplePsdError = '密码为8-20位字符，需包含大写字母，小写字母和数字'
// 手机号验证
/* eslint-disable-next-line */
export const checkPhone = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入手机号'))
  }
  const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
  if (reg.test(value)) {
    callback()
  } else {
    return callback(new Error('请输入正确的手机号'))
  }
}
export const checkName = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入姓名'))
  }
  const reg = /^[\u4E00-\u9FA5]{1,10}$/
  if (reg.test(value)) {
    return callback()
  }
  return callback(new Error('姓名为1-10字的中文'))
}
export const checkAccount = (rule, value, callback) => {
  if (!value) {
    return callback()
  }
  // 6-18位的数字或者字母
  const reg = /^[A-Za-z0-9]{6,18}$/
  if (reg.test(value)) {
    callback()
  } else {
    return callback(new Error('账号为6-18位数字或者字母'))
  }
}
export const checkUserID = (rule, value, callback) => {
  if (!value) {
    return callback()
  }
  // 2-5位数字
  const reg = /^[0-9]{2,5}$/
  if (reg.test(value)) {
    callback()
  } else {
    return callback(new Error('员工编号为2-5位数字'))
  }
}
